import { Injectable, Optional, ɵɵdefineInjectable, ɵɵinject, Component, ViewEncapsulation, ViewChild, Input, HostListener, NgModule, SkipSelf, EventEmitter, Output, Directive, ElementRef, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormControl, ReactiveFormsModule, FormBuilder, FormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/theme.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ThemeServiceConfig {
    constructor() {
        this.theme = 'bmw';
    }
}
if (false) {
    /** @type {?} */
    ThemeServiceConfig.prototype.theme;
}
class ThemeService {
    /**
     * @param {?=} config
     */
    constructor(config) {
        this.theme = 'bmw';
        //Theming for directives can only be done via JS
        this.brands = {
            bmw: {
                primaryColour: '#1c69d3',
                secondaryColour: '#9c9d9d'
            },
            mini: {
                primaryColour: 'pink',
                secondaryColour: 'red'
            }
        };
        if (config) {
            this.theme = config.theme;
        }
    }
    /**
     * @return {?}
     */
    getTheme() {
        // console.log(this.brands);
        // console.log(this.theme);
        // console.log(this.brands[this.theme]);
        return this.brands[this.theme];
    }
}
ThemeService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ThemeService.ctorParameters = () => [
    { type: ThemeServiceConfig, decorators: [{ type: Optional }] }
];
/** @nocollapse */ ThemeService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ThemeService_Factory() { return new ThemeService(ɵɵinject(ThemeServiceConfig, 8)); }, token: ThemeService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ThemeService.prototype.theme;
    /** @type {?} */
    ThemeService.prototype.brands;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tooltip/tooltip.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TooltipComponent {
    /**
     * @param {?} configService
     */
    constructor(configService) {
        this.isActive = false;
        this.theme = configService.theme;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeydownHandler(event) {
        this.closeContent();
    }
    /**
     * @return {?}
     */
    closeContent() {
        this.isActive = false;
    }
    /**
     * @return {?}
     */
    toggleContent() {
        this.isActive = !this.isActive;
    }
}
TooltipComponent.decorators = [
    { type: Component, args: [{
                selector: 'bmwg-tooltip',
                template: "<div class=\"bmwg-tool-tip\" [class.isActive]=\"isActive\" [ngClass]=\"theme\">\n\n    <div (click)=\"toggleContent()\" class=\"bmwg-tool-tip__trigger\">\n        <svg class=\"bmwg-tool-tip__icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <path\n                d=\"M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z\"/>\n        </svg>\n    </div>\n\n    <div class=\"bmwg-tool-tip__content-container\" #contentEl *ngIf=\"isActive\">\n        <header class=\"bmwg-tool-tip__header\">\n            <svg class=\"bmwg-tool-tip__icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n                <path\n                    d=\"M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z\"/>\n            </svg>\n            <div (click)=\"toggleContent()\" class=\"bmwg-tool-tip__cross bmwg-tool-tip__trigger\">\n                <svg class=\"bmwg-tool-tip__icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n                    <path\n                        d=\"M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z\"/>\n                </svg>\n            </div>\n        </header>\n        <div [innerHTML]=\"content\" class=\"bmwg-tool-tip__content\"></div>\n    </div>\n\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmwg-tool-tip{position:relative}.bmwg-tool-tip.isActive:after{content:\"\";background:rgba(0,0,0,.3);position:fixed;top:0;left:0;bottom:0;right:0;z-index:2}.bmwg-tool-tip__cross,.bmwg-tool-tip__icon{width:20px;height:20px}.bmwg-tool-tip__trigger{cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:0;background:0 0;border:0;padding:0;margin:0;position:relative}.bmwg-tool-tip__content-container{display:-webkit-box;display:flex;position:fixed;left:20vw;right:20vw;top:20vh;background:#fff;z-index:11;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:20px}@media (max-width:768px){.bmwg-tool-tip__content-container{top:10vh;right:5vw;left:5vw;max-height:75vh;overflow-y:scroll}}.bmwg-tool-tip__content-container header{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;margin-bottom:10px;-webkit-box-align:center;align-items:center}.bmwg-tool-tip__content-container .bmwg-tool-tip__content{overflow-y:auto}.bmwg-tool-tip.bmw .bmwg-tool-tip__header .bmwg-tool-tip__icon,.bmwg-tool-tip.bmw .bmwg-tool-tip__trigger .bmwg-tool-tip__icon,.bmwg-tool-tip.bmw__cross,.bmwg-tool-tip.bmw__icon{fill:#1c69d3}.bmwg-tool-tip.mini .bmwg-tool-tip__header .bmwg-tool-tip__icon,.bmwg-tool-tip.mini .bmwg-tool-tip__trigger .bmwg-tool-tip__icon,.bmwg-tool-tip.mini__cross,.bmwg-tool-tip.mini__icon{fill:#4a4a4a}"]
            }] }
];
/** @nocollapse */
TooltipComponent.ctorParameters = () => [
    { type: ThemeService }
];
TooltipComponent.propDecorators = {
    contentEl: [{ type: ViewChild, args: ['contentEl', { static: false },] }],
    content: [{ type: Input }],
    onKeydownHandler: [{ type: HostListener, args: ['document:keydown.escape', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    TooltipComponent.prototype.theme;
    /** @type {?} */
    TooltipComponent.prototype.contentEl;
    /** @type {?} */
    TooltipComponent.prototype.content;
    /** @type {?} */
    TooltipComponent.prototype.isActive;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tooltip/tooltip.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BmwgTooltipModule {
    /**
     * @param {?=} parentModule
     */
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('BmwgTooltipModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: BmwgTooltipModule,
            providers: [
                { provide: ThemeServiceConfig, useValue: config }
            ]
        };
    }
}
BmwgTooltipModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    TooltipComponent
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    TooltipComponent
                ]
            },] }
];
/** @nocollapse */
BmwgTooltipModule.ctorParameters = () => [
    { type: BmwgTooltipModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/marketing-preferences/marketing-preferences.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MarketingPreferencesComponent {
    constructor() {
        this.selectedOptions = new EventEmitter();
        this.options = new FormGroup({
            app: new FormControl(false),
            email: new FormControl(false),
            mail: new FormControl(false),
            phone: new FormControl(false),
            sms: new FormControl(false),
            car: new FormControl(false),
        });
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.initialValue) {
            this.options.controls['app'].setValue(this.initialValue.app);
            this.options.controls['email'].setValue(this.initialValue.email);
            this.options.controls['mail'].setValue(this.initialValue.mail);
            this.options.controls['phone'].setValue(this.initialValue.phone);
            this.options.controls['sms'].setValue(this.initialValue.sms);
            this.options.controls['car'].setValue(this.initialValue.car);
        }
        this.selectedOptions.emit(this.options.value);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.options.valueChanges.subscribe((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            this.selectedOptions.emit(val);
        }));
    }
}
MarketingPreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'bmwg-marketing-preferences',
                template: "<div class=\"bmwg-marketing-preferences\">\n    <div class=\"interface\">\n        <h1 class=\"title\">{{title}}</h1>\n        <div class=\"bmwg-marketing-preferences__intro-text\" data-e2e=\"marketing-text\">\n            <p>{{intro}}</p>\n            <bmwg-tooltip *ngIf=\"toolTipMarketingPreferences\"\n                [content]=\"toolTipMarketingPreferences\"\n                          data-e2e=\"terms-and-conditions\">\n            </bmwg-tooltip>\n        </div>\n        <form [formGroup]=\"options\" class=\"bmwg-marketing-preferences__options-form\" data-e2e=\"marketing-channels\">\n            <label for=\"bmwg-marketing-preferences__option-app\">\n                <input id=\"bmwg-marketing-preferences__option-app\" type=\"checkbox\" formControlName=\"app\" />\n                <span>Apps of the BMW Group</span>\n            </label>\n            <label for=\"bmwg-marketing-preferences__option-email\">\n                <input id=\"bmwg-marketing-preferences__option-email\" type=\"checkbox\" formControlName=\"email\" />\n                <span>Email</span>\n            </label>\n\n            <label for=\"bmwg-marketing-preferences__option-phone\">\n                <input id=\"bmwg-marketing-preferences__option-phone\" type=\"checkbox\" formControlName=\"phone\">\n                <span>Phone</span>\n            </label>\n\n            <label for=\"bmwg-marketing-preferences__option-mail\">\n                <input id=\"bmwg-marketing-preferences__option-mail\" type=\"checkbox\" formControlName=\"mail\">\n                <span>Mail</span>\n            </label>\n\n            <label for=\"bmwg-marketing-preferences__option-sms\">\n                <input id=\"bmwg-marketing-preferences__option-sms\" type=\"checkbox\" formControlName=\"sms\">\n                <span>SMS (Messenger Services)</span>\n            </label>\n\n            <label for=\"bmwg-marketing-preferences__option-car\">\n                <input id=\"bmwg-marketing-preferences__option-car\" type=\"checkbox\" formControlName=\"car\">\n                <span>In-car (If supported)</span>\n            </label>\n\n        </form>\n\n        <div class=\"instructions\">\n            <p>{{instructions}}\n                <bmwg-tooltip *ngIf=\"toolTipOptOut\" [content]=\"toolTipOptOut\" data-e2e=\"consent\"></bmwg-tooltip>\n            </p>\n\n        </div>\n\n    </div>\n    <div class=\"bmwg-marketing-preferences__notice\" data-e2e=\"benefits-text\">\n        <h3>{{noticeTitle}}</h3>\n        <ul>\n            <li *ngFor=\"let benefit of benefitsList\">{{benefit.label}}</li>\n        </ul>\n    </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmwg-marketing-preferences__intro-text{display:-webkit-box;display:flex}.bmwg-marketing-preferences__notice{z-index:-10;position:relative}.bmwg-marketing-preferences .instructions .bmwg-tool-tip{display:inline-block}"]
            }] }
];
/** @nocollapse */
MarketingPreferencesComponent.ctorParameters = () => [];
MarketingPreferencesComponent.propDecorators = {
    title: [{ type: Input }],
    intro: [{ type: Input }],
    instructions: [{ type: Input }],
    noticeTitle: [{ type: Input }],
    benefitsList: [{ type: Input }],
    toolTipMarketingPreferences: [{ type: Input }],
    toolTipOptOut: [{ type: Input }],
    initialValue: [{ type: Input }],
    policyVersion: [{ type: Input }],
    selectedOptions: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MarketingPreferencesComponent.prototype.title;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.intro;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.instructions;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.noticeTitle;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.benefitsList;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.toolTipMarketingPreferences;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.toolTipOptOut;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.initialValue;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.policyVersion;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.selectedOptions;
    /** @type {?} */
    MarketingPreferencesComponent.prototype.options;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/marketing-preferences/marketing-preferences.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BmwgMarketingPreferencesModule {
    /**
     * @param {?=} parentModule
     */
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('BmwgMarketingPreferencesModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: BmwgMarketingPreferencesModule,
            providers: [
                { provide: ThemeServiceConfig, useValue: config }
            ]
        };
    }
}
BmwgMarketingPreferencesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    MarketingPreferencesComponent
                ],
                imports: [
                    ReactiveFormsModule,
                    CommonModule,
                    BmwgTooltipModule.forRoot({ theme: 'bmw' })
                ],
                exports: [
                    MarketingPreferencesComponent
                ]
            },] }
];
/** @nocollapse */
BmwgMarketingPreferencesModule.ctorParameters = () => [
    { type: BmwgMarketingPreferencesModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/button/button.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ButtonDirective {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     * @param {?} theme
     */
    constructor(elementRef, renderer, theme) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.theme = theme;
        this.importance = 'primary';
        this.activeTheme = this.theme.getTheme();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let newStyles = {
            'background-color': this.activeTheme.primaryColour,
            'color': '#fff',
            'font-weight': 'bold',
            'padding': '0px 20px',
            'line-height': '40px',
            'font-size': '14px'
        };
        if (this.importance === 'secondary') {
            newStyles['background-color'] = this.activeTheme.secondaryColour;
        }
        Object.keys(newStyles).forEach((/**
         * @param {?} element
         * @return {?}
         */
        element => {
            this.renderer.setStyle(this.elementRef.nativeElement, `${element}`, newStyles[element]);
        }));
    }
}
ButtonDirective.decorators = [
    { type: Directive, args: [{
                selector: '[bmwgButton]'
            },] }
];
/** @nocollapse */
ButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ThemeService }
];
ButtonDirective.propDecorators = {
    bmwgButton: [{ type: Input }],
    importance: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ButtonDirective.prototype.bmwgButton;
    /** @type {?} */
    ButtonDirective.prototype.importance;
    /** @type {?} */
    ButtonDirective.prototype.activeTheme;
    /**
     * @type {?}
     * @private
     */
    ButtonDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    ButtonDirective.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    ButtonDirective.prototype.theme;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/button/button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BmwgButtonModule {
    /**
     * @param {?=} parentModule
     */
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('BmwgButtonModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: BmwgButtonModule,
            providers: [
                { provide: ThemeServiceConfig, useValue: config }
            ]
        };
    }
}
BmwgButtonModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ButtonDirective
                ],
                exports: [
                    ButtonDirective
                ]
            },] }
];
/** @nocollapse */
BmwgButtonModule.ctorParameters = () => [
    { type: BmwgButtonModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/radio-buttons/radio-buttons.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RadiosComponent {
    /**
     * @param {?} configService
     * @param {?} formBuilder
     */
    constructor(configService, formBuilder) {
        this.formBuilder = formBuilder;
        this.formPart = new FormGroup({});
        this.selectedOptions = new EventEmitter();
        this.theme = configService.theme;
        this.formPart = this.formBuilder.group({
            radioOption: ""
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.formPart.controls['radioOption'].setValue((this.defaultValue) ? this.defaultValue : this.radios[0].value);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.formPart.valueChanges.subscribe((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            this.selectedOptions.emit(val);
        }));
    }
}
RadiosComponent.decorators = [
    { type: Component, args: [{
                selector: 'bmwg-radios',
                template: "<div class=\"bmwg-radios\" [ngClass]=\"theme\">\n\n    <form [formGroup]=\"formPart\" class=\"bmwg-radios__form\" data-e2e=\"radio-buttons\">\n        <label class=\"radio\" *ngFor=\"let radio of radios; let i=index\">\n            <input type=\"radio\"\n                   [id]=\"i\"\n                   formControlName=\"radioOption\"\n                   name=\"radioOption\"\n            [value]=\"radio.value\">\n            <span>{{radio.label}}</span>\n            <span class=\"checkmark\"></span>\n        </label>\n    </form>\n\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmwg-radios *{box-sizing:border-box}.bmwg-radios .bmwg-radios__form{display:-webkit-box;display:flex}.bmwg-radios .bmwg-radios__form .radio{min-height:60px;position:relative;-webkit-box-flex:1;flex:1;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;cursor:pointer}.bmwg-radios .bmwg-radios__form .radio:nth-child(2) .checkmark{border-left:0}.bmwg-radios .bmwg-radios__form .radio input{position:absolute;opacity:0}.bmwg-radios .bmwg-radios__form .radio span{font-size:18px;z-index:2;text-align:center;margin:auto;line-height:30px;padding:20px}.bmwg-radios .bmwg-radios__form .radio .checkmark{z-index:1;width:100%;height:100%;position:absolute;top:0;left:0}.bmwg-radios.bmw .bmwg-radios__form .radio span{color:#000}.bmwg-radios.bmw .bmwg-radios__form .radio input:checked~.checkmark{background-color:#1c69d3}.bmwg-radios.bmw .bmwg-radios__form .radio input:checked~span{color:#fffffe}.bmwg-radios.bmw .bmwg-radios__form .checkmark{border:1px solid #e7e7e7}.bmwg-radios.mini .bmwg-radios__form .radio{text-transform:uppercase}.bmwg-radios.mini .bmwg-radios__form .radio span{color:#000}.bmwg-radios.mini .bmwg-radios__form .radio input:checked~.checkmark{background-color:#000}.bmwg-radios.mini .bmwg-radios__form .radio input:checked~span{color:#fffffe}.bmwg-radios.mini .bmwg-radios__form .checkmark{border:1px solid #000}"]
            }] }
];
/** @nocollapse */
RadiosComponent.ctorParameters = () => [
    { type: ThemeService },
    { type: FormBuilder }
];
RadiosComponent.propDecorators = {
    selectedOptions: [{ type: Output }],
    radios: [{ type: Input }],
    radioGroupName: [{ type: Input }],
    defaultValue: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    RadiosComponent.prototype.theme;
    /** @type {?} */
    RadiosComponent.prototype.formPart;
    /** @type {?} */
    RadiosComponent.prototype.selectedOptions;
    /** @type {?} */
    RadiosComponent.prototype.radios;
    /** @type {?} */
    RadiosComponent.prototype.radioGroupName;
    /** @type {?} */
    RadiosComponent.prototype.defaultValue;
    /**
     * @type {?}
     * @private
     */
    RadiosComponent.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/radio-buttons/radio-buttons.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BmwgRadiosModule {
    /**
     * @param {?=} parentModule
     */
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('BmwgRadiosModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: BmwgRadiosModule,
            providers: [
                { provide: ThemeServiceConfig, useValue: config }
            ]
        };
    }
}
BmwgRadiosModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    RadiosComponent
                ],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    FormsModule
                ],
                exports: [
                    RadiosComponent
                ]
            },] }
];
/** @nocollapse */
BmwgRadiosModule.ctorParameters = () => [
    { type: BmwgRadiosModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: bmwg-angular-library.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BmwgButtonModule, BmwgMarketingPreferencesModule, BmwgRadiosModule, BmwgTooltipModule, TooltipComponent as ɵa, ThemeServiceConfig as ɵb, ThemeService as ɵc, MarketingPreferencesComponent as ɵd, ButtonDirective as ɵe, RadiosComponent as ɵf };
//# sourceMappingURL=bmwg-angular-library.js.map
